import type { AvailabilityErrorCode } from "@gettactic/api";

export const timeRelatedErrorCodes: AvailabilityErrorCode[] = [
  "resource_unavailable",
  "overlaps_with_schedule",
  "overlaps_with_recurring_task",
  "resource_over_capacity",
  "concurrent_not_allowed",
  "concurrent_not_allowed_cross_office",
  "buffer_overlaps_with_schedule"
];
